import React from 'react'
import Button from '../button'
import Cookies from 'js-cookie'
import { useStore } from '@/src/types/store'
import { useRouter } from 'next/router'
import { WaringIcon } from '@/src/assets/icons'

const Popup = () => {
  const { profile } = useStore()
  const router = useRouter()

  const exitImpersonation = () => {
    Cookies.remove('server_user_id')
    Cookies.remove('user_id')
    router
      .push({
        pathname: '/admin'
      })
      .then(() => {
        window.location.reload()
      })
  }

  if (!profile.first_name && !profile.last_name && !profile.business_name) {
    return null
  }

  return (
    <div className="flex items-center justify-between bg-[#FDEDED] text-xs text-[#5F2120] px-4 py-2.5">
      <div className="flex items-center gap-1">
        <WaringIcon fill="#D32F2F" />
        You are impersonating {profile.first_name} {profile.last_name} from {profile.business_name}
      </div>
      <div className="flex gap-2">
        <Button
          onClick={exitImpersonation}
          text="Exit"
          variant="outlined"
          color="#D32F2F"
          classes="rounded-[0.625rem] font-semibold text-[0.938rem] !text-[#D32F2F] border-[#D32F2F80]"
        />
      </div>
    </div>
  )
}

export default Popup
